// Het overzicht onder `?`. Klein maar geliefd: Keep, Obsidian en Gmail hebben het allemaal,
// en het is de goedkoopste manier om te laten zien dat de app sneller kan dan met de muis.

import { Icoon } from "./Icoon.tsx";

const RIJEN: { toets: string; wat: string }[] = [
  { toets: "Ctrl + K", wat: "Zoeken en springen (het commandopalet)" },
  { toets: "c", wat: "Nieuwe notitie" },
  { toets: "Ctrl + F", wat: "Zoeken binnen deze notitie" },
  { toets: "[[", wat: "Link naar een andere notitie" },
  { toets: "#", wat: "Tag; typ hem gewoon in de tekst" },
  { toets: "Ctrl + Enter", wat: "Snelle notitie bewaren en sluiten" },
  { toets: "Esc", wat: "Venster sluiten" },
  { toets: "?", wat: "Dit overzicht" }
];

export function Sneltoetsen({ sluit }: { sluit: () => void }) {
  return (
    <div className="overlay" onClick={sluit}>
      <div className="paneel" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Sneltoetsen">
        <div className="paneelkop">
          <Icoon naam="notitie" grootte={18} />
          <strong style={{ flexGrow: 1, fontFamily: "var(--schrift-titel)", fontSize: 18 }}>Sneltoetsen</strong>
          <button className="knop stil" onClick={sluit} aria-label="Sluiten">
            <Icoon naam="kruis" grootte={15} />
          </button>
        </div>
        <div className="paneelinhoud">
          {RIJEN.map((rij) => (
            <div key={rij.toets} style={{ display: "flex", alignItems: "center", gap: 12, padding: "9px 12px" }}>
              <kbd
                style={{
                  fontFamily: "var(--schrift-code)", fontSize: 12, minWidth: 92, textAlign: "center",
                  border: "1px solid var(--lijn)", borderRadius: 6, padding: "3px 8px", background: "var(--lijstvlak)"
                }}
              >
                {rij.toets}
              </kbd>
              <span>{rij.wat}</span>
            </div>
          ))}
        </div>
        <div className="paneelvoet">
          <span>In de zoekbalk kun je filteren met tag:, boek:, is:taak en gewijzigd:dag-7</span>
        </div>
      </div>
    </div>
  );
}
